import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Donate from "./pages/Donate";
import SignUp from "./pages/SignUp";
import Admin from "./pages/Admin";
import KnowMore from "./components/knowmore";
import Needhelp from "./components/Needhelp";
import TermsAndPrivacyPolicy from "./components/TermsAndPrivacyPolicy";
import AdminDashboard from "./pages/AdminDashboard";
import Members from "./components/Members";
import Collection from "./components/Collection";
import Report from "./components/Report";
import Verification from "./components/Verification";
import Mails from "./components/Mails";
import Theme from "./components/Theme";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import WAM from "./components/WAM";
import MemberAgreementForm from "./components/MemberAgreementForm";
import SadqaBoxForm from "./components/SadqaBoxForm";
import VolunteerAgreementForm from "./components/VolunteerAgreementForm";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/event" element={<Events />} />
        <Route
          exact
          path="/TermsAndPrivacyPolicy"
          element={<TermsAndPrivacyPolicy />}
        />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/donate" element={<Donate />} />
        <Route exact path="/signup" element={<SignUp />} />
        <Route exact path="/admin" element={<Admin />} />
        <Route exact path="/needhelp" element={<Needhelp />} />
        <Route exact path="/wam" element={<WAM />} />
        <Route exact path="/new" element={<KnowMore />} />
        <Route exact path="/new" element={<KnowMore />} />
        <Route path="/knowmore" element={<KnowMore />} />
        <Route path="/members" element={<Members />} />
        <Route path="/collection" element={<Collection />} />
        <Route path="/report" element={<Report />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/mails" element={<Mails />} />
        <Route path="/theme" element={<Theme />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/member-agreement" element={<MemberAgreementForm />} />
        <Route path="/sadqa-box" element={<SadqaBoxForm />} />
        <Route path="/volunteer-agreement" element={<VolunteerAgreementForm />} />
        <Route
          path="/admindashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route exact path="*" element={<Navigate to={"/"} />} />
      </Routes>
    </BrowserRouter>
  );
}
